import { render, staticRenderFns } from "./AppLandingCardOnlineDevices.vue?vue&type=template&id=2b1d5e4a&scoped=true&"
import script from "./AppLandingCardOnlineDevices.vue?vue&type=script&lang=js&"
export * from "./AppLandingCardOnlineDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1d5e4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
